import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	themes: [],
	currentTheme: {},
	defaultTheme: {},
	themeNav: [
		{ route: "pages", name: "Page Styles" },
		{ route: "navigation", name: "Navigation Styles" },
		{ route: "texts", name: "Text Styles" },
		{ route: "buttons", name: "Button Styles" },
		{ route: "card", name: "Card Styles" },
		{ route: "controls", name: "Input Styles" },
		{ route: "lists", name: "List Styles" },
		{ route: "extra", name: "Shadow Styles" },
	],
	pickingThemeTemplate: false,
};

export default function themesReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_THEMES_SUCCESS:
			return {
				...state,
				themes: action.themes,
			};

		case ActionTypes.SELECT_THEME_SUCCESS:
			return {
				...state,
				currentTheme: action.theme,
			};

		case ActionTypes.LOAD_DEFAULT_THEME_SUCCESS:
			return {
				...state,
				defaultTheme: action.theme,
			};

		case ActionTypes.RESET_CURRENT_THEME:
			return {
				...state,
				currentTheme: {},
			};
		case ActionTypes.PICKING_THEME_TEMPLATE:
			return {
				...state,
				pickingThemeTemplate: true,
			};
		case ActionTypes.PICKING_THEME_TEMPLATE_FINISHED:
			return {
				...state,
				pickingThemeTemplate: false,
			};
		default:
			return state;
	}
}
